import { render, staticRenderFns } from "./FloatingUpload.vue?vue&type=template&id=40df9ef7&scoped=true"
import script from "./FloatingUpload.vue?vue&type=script&lang=js"
export * from "./FloatingUpload.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=40df9ef7&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40df9ef7",
  null
  
)

export default component.exports